/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-29 22:26:32
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-29 22:27:00
 * @FilePath: /ack-slh-frontend/src/utils/Root/index.ts
 */
class Root {
  modalRoot: any;
  constructor(id?: any) {
    this.modalRoot = document.getElementById(id || 'modal-root');
  }
  getRoot() {
    const el = document.createElement('div');
    const re = this.modalRoot.appendChild(el);
    return re;
    //ReactDOM.render(node, el);
  }
  clearAll() {
    this.modalRoot.innerHTML = '';
  }
  delete(node: any) {
    try {
      if (this.modalRoot.hasChildNodes()) this.modalRoot.removeChild(node);
    } catch (e) {
      console.warn(e);
    }
  }
  replace() {
    this.clearAll();
    return this.getRoot();
  }
}
export { Root };
